import { all, takeLatest } from 'redux-saga/effects';

import { jurisdictionsRequest } from '@store/jurisdictions';

import { handleFetchJurisdictionsRequest } from './handleFetchJurisdictionsRequest';

export default all([takeLatest(jurisdictionsRequest.type, handleFetchJurisdictionsRequest)]);
